import { IContact } from 'clickNgo/entities/contact'
import { getUrlParam } from 'core-components/helpers/url'
import { Tooltip } from 'core-components/library/tooltip'
import { useContactsWithMultiplePartners } from 'onboarding/hooks/useContactsWithMultiplePartners'

import { getUniquePartnerIds } from './helpers/getUniquePartnerIds'

import styles from './MultipleContactWarning.module.scss'

interface IMultipleContactWarning {
  email?: string
  contacts?: IContact[]
}

export const MultipleContactWarning = ({ email, contacts }: IMultipleContactWarning) => {
  const { contacts: contactsWithMultiplePartners } = useContactsWithMultiplePartners(
    +getUrlParam('rid')
  )

  if (!contactsWithMultiplePartners || contactsWithMultiplePartners?.length === 0) {
    return null
  }

  let partnerIds = getUniquePartnerIds(contactsWithMultiplePartners, email)

  if (contacts) {
    partnerIds = contacts
      .map((contact) => {
        return getUniquePartnerIds(contactsWithMultiplePartners, contact.email)
      })
      .flat()
  }

  if (partnerIds.length === 0) {
    return null
  }

  return (
    <Tooltip
      className={styles.icon}
      tipContent={() => <>{`Contact already exists under partner id: ${partnerIds}`}</>}
    >
      <i className="kbase kbase-warning-alt" />
    </Tooltip>
  )
}
